import axios from 'axios';
import authHeader from "../../services/auth-header";
import ConstApiUrls from "../../services/const-api-urls";

const API_URL = ConstApiUrls.API_SERVICE_URL

class FMaterialGroup2Service {
    getApiUrl() {
        return API_URL
    }

    getAllFMaterialGroup2(){
        return axios.get(API_URL + `getAllFMaterialGroup2`, { headers: authHeader() });
    }
    getAllFMaterialGroup2Containing(page, pageSize, sortBy, order, search){
        // return axios.get(API_URL + `getAllFMaterialGroup2`, { headers: authHeaderMultipart() });
        return axios.get(API_URL + `getAllFMaterialGroup2Containing?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&order=${order}&search=${search}`, { headers: authHeader() });
    }
    getFMaterialGroup2ById(id){
        return axios.get(API_URL + `getFMaterialGroup2ById/${id}`, { headers: authHeader() });
    }
    updateFMaterialGroup2(item){
        return axios.put(API_URL + `updateFMaterialGroup2/${item.id}`, item, {headers: authHeader()})
    }
    createFMaterialGroup2(item){
        return axios.post(API_URL + `createFMaterialGroup2`, item, {headers: authHeader()})
    }
    deleteFMaterialGroup2(id){
        return axios.delete(API_URL + `deleteFMaterialGroup2/${id}`, {
            headers: authHeader()
        });
    }
    deleteAllFMaterialGroup2(itemIds){
        // let user = JSON.parse(localStorage.getItem('user'));
        // return axios.delete(API_URL + `deleteAllFMaterialGroup2`, {
        //     headers:  authHeaderMultipart(),
        //     data: {
        //         message: 'delete  success'
        //     }
        // });
        return axios.delete(API_URL + `deleteAllFMaterialGroup2`, {
            headers:  authHeader(),
            data: itemIds
        });


    }
}
export default new FMaterialGroup2Service()